import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { guardAgainstStaleBundle } from './utils/staleBundleGuard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fire-and-forget: a tab holding a cached index.html would otherwise keep
// running a superseded bundle and show layout fixed weeks ago as still broken.
void guardAgainstStaleBundle();

